<template>
  <div v-if="item">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7" v-if="item && item.site">
              [{{item.site.name}}] - {{item.site.fqdn}}
            </div>
            <div class="mb7">
              <span class="float-right" v-show="item.finished_at">{{item.created_at | datetime }} ~ {{item.finished_at  ? item.finished_at : '~' | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>사이트 페이지</label><br>
                <label for="ph_page">{{item.page_count }} 페이지</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>외부 페이지</label><br>
                <label for="ph_ext">{{item.ext_count}} 페이지</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>탐지 페이지</label><br>
                <label for="ph_detect">{{item.detect_count}} 페이지</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>리소스 페이지</label><br>
                <label for="ph_detect">{{item.resource_count}} 페이지</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>화면 캡쳐</label><br>
                <a><img class="border" :src="image" :style="{ width: thumbnail_size }"></a>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              페이지 목록
            </div>
            <div class="mb7">
               <small>페이지들 목록 :{{item.page_count || 0 | number}} 페이지 ({{result.page.start+(item.page_count ? 1 : 0)}} ~ {{result.page.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.page_count === 0"><template><div>데이터가 없습니다.</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_page" ref="page_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.page.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              외부 페이지
            </div>
            <div class="mb7">
              <small>외부 사이트 방문 목록 :{{item.ext_count|number}} 페이지 ({{result.ext.start+(item.ext_count ? 1 : 0)}} ~ {{result.ext.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.ext_count === 0 || result.ext.data == ''"><template><div>데이터가 없습니다.</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_ext" ref="ext_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.ext.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              리소스 데이터
            </div>
            <div class="mb7">
              <small>리소스 데이터 목록 :{{item.resource_count|number}} 개 ({{result.resource.start+(item.resource_count ? +1 : 0)}} ~ {{result.resource.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.resoure_count === 0 || result.resource.data == ''"><template><div>데이터가 없습니다.</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_resource" ref="resource_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.resource.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              탐지 목록
            </div>
            <div class="mb7">
              <small>탐지 패턴 목록 :{{item.detect_count|number}} 개 ({{result.detect.start+(item.detect_count ? 1: 0)}} ~ {{result.detect.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.detect_count === 0"><template><div>데이터가 없습니다.</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_detect" ref="detect_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.detect.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>